import { gqlClient } from 'gql-client';
import { gql } from 'graphql.macro';
import { messages } from 'messages';
import { useState, useEffect } from 'react';
import { showError } from 'utils/notify';

const getBrands = gql`query GetBranCar($limit: Int) { car_brand(limit: $limit) }`;

let _brand:any[] = [];
let _brandList:any[] = [];

export const useBrands = () => {
  const [ brands, setBrands ] = useState(_brand);
  const [ brandList, setBrandList ] = useState(_brandList);
  useEffect(() => {
    if (!brands.length || !brandList.length) {
      gqlClient.query({ query: getBrands, variables: {}, })
        .then((response) => {
          const res = response?.data?.car_brand;
          if (res) {
            _brand = res;
            _brandList = res?.map((item:any) => item?.name);
            setBrands(res);
            setBrandList(_brandList);
          }
        })
        .catch(() => showError(messages?.DATA_LOAD_FAILED));
    }
  }, []);

  return {
    brands, brandList
  };
};
